
import { CSSProperties } from 'vue';
import { Component, mixins } from 'nuxt-property-decorator';
import {
  headerSectionImageHeightModifiersMap,
  contentBlockTextHorizontalAlignmentModifiersMap,
} from '../../../services';
import WebsiteHeaderMixin from './WebsiteHeaderMixin';

@Component
export default class WebsiteHeaderFullWidth extends mixins(WebsiteHeaderMixin) {
  get rootStyles(): CSSProperties {
    return { '--overlay-opacity': this.headerSection?.opacity ?? '' };
  }

  get rootClassNames(): Array<string | Record<string, boolean>> {
    return [
      headerSectionImageHeightModifiersMap[this.headerSection.imageHeight],
      contentBlockTextHorizontalAlignmentModifiersMap[this.headerSection.textHorizontalAlignment],
    ];
  }
}
